import { authenticatedRequest } from './api.service';
import {
  VakQuestionsResponse,
  VakLastTestResponse,
  VakSubmitRequest,
  VakSubmitResponse, VakLastTestResponseFail
} from "../typings/vak";

export const vakService = {
  getAllQuestions: async (
    randomize: boolean = true
  ): Promise<VakQuestionsResponse> => {
    const response = await authenticatedRequest("GET", "/vak/questions/all", {
      randomize,
    });
    return response as unknown as VakQuestionsResponse;
  },

  getLastTest: async (
    withCount: boolean = false
  ): Promise<VakLastTestResponse | VakLastTestResponseFail> => {
    try {
      const params = withCount ? { wc: 1 } : {};
      const response = await authenticatedRequest(
        "GET",
        "/vak/last-test",
        params
      );
      return {...response, status:true} as unknown as VakLastTestResponse;
    } catch (e: any){
      return { data: { countUser: e?.message?.data?.countUser }, message: e?.message?.message };
    }
  },

  submitTest: async (answers: VakSubmitRequest): Promise<VakSubmitResponse> => {
    const response = await authenticatedRequest(
      "POST",
      "/vak/submit-test",
      answers
    );
    return response as unknown as VakSubmitResponse;
  },

  getAIRecommendation: async (testId: number): Promise<any> => {
    const response = await authenticatedRequest(
      "POST",
      `/vak/ai-recommendation/${testId}`
    );
    return response as unknown as any;
  },

  getTestById: async (testId: number): Promise<VakLastTestResponse> => {
    const response = await authenticatedRequest("GET", `/vak/test/${testId}`);
    return response as unknown as VakLastTestResponse;
  },

  getPdfStatus: async (testId: number): Promise<any> => {
    const response = await authenticatedRequest(
      "GET",
      `/vak/pdf-status/${testId}`
    );
    return response as unknown as any;
  },

  downloadPdf: async (testId: number): Promise<Blob> => {
    const response = await authenticatedRequest(
      "POST",
      `/vak/download-pdf/${testId}`,
      {},
      { responseType: "blob" }
    );
    return response as unknown as Blob;
  },
};